<template>
  <div>

    <c-title
      v-if="processes.length || $is(['applicant'])"
      tag="h2"
    >Förderprogramm</c-title>

    <span v-if="$is(['applicant']) && !processes.length">
      Sie haben bisher keine Bewerbung gestartet. Bitte wählen Sie ein Programm.
    </span>

    <c-busy v-if="loadStatus === $config.status.LOADING" />

    <c-card
      v-for="process in processes"
      :key="process.identifier"
    >
      <c-title tag="h3">
        <span v-if="$is(['applicant']) === false">{{ process.user.first_name }} {{ process.user.last_name }}: </span>
        {{ process.workflow.title }}
      </c-title>

      <p><i>{{ process.workflow.subtitle }}</i></p>

      <p>
        <c-badge :type="badgeType[process.status]">
          {{ processType[process.status] || 'Unbekannt' }}
        </c-badge>
      </p>

      <c-button-router-link
        v-if="$is(['applicant']) && process.status === 'Started'"
        :to="{
          name: 'process-edit',
          params: { identifier: process.identifier }
        }"
      >
        Daten bearbeiten
      </c-button-router-link>

      <c-button-router-link
        v-if="process.workflow.enable_rating && process.status === 'Accepted'"
        :to="{
          name: 'process-rating-list',
          params: { identifier: process.identifier }
        }"
      >
        Bewertungen
      </c-button-router-link>

    </c-card>

  </div>
</template>

<script>
import CBadge from '@/components/CBadge'
import CButtonRouterLink from '@/components/CButtonRouterLink'
import CBusy from '@/components/CBusy'
import CCard from '@/components/CCard'
import CTitle from '@/components/CTitle'

import handleRequestError from '@/functions/handleRequestError'

export default {
  name: 'CProcessOverview',

  components: {
    CBadge,
    CButtonRouterLink,
    CBusy,
    CCard,
    CTitle
  },

  data () {
    return {
      processType: {
        Started: 'Gestartet',
        Pending: 'Wird bearbeitet',
        Accepted: 'Angenommen',
        Denied: 'Abgelehnt'
      },
      badgeType: {
        Accepted: 'success',
        Denied: 'error'
      },
      loadStatus: this.$config.status.IDLE
    }
  },

  computed: {
    processes () {
      return this.$store.state.configuration.processes
    }
  },

  created () {
    this.loadStatus = this.$config.status.LOADING

    this.$api.get('workflow/process/')
      .then(response => {
        this.$store.commit('configuration/updateProcesses', response.data)
        this.loadStatus = this.$config.status.SUCCESS
      })
      .catch(error => {
        handleRequestError({
          error,
          fallback: 'Ihre Förderprogramme konnten nicht geladen werden. Bitte versuchen sie es später erneut.'
        })

        this.loadStatus = this.$config.status.ERROR
      })
  }
}
</script>
